import React from "react";

const NotificationManager: React.FC = () => {
  // OneSignal handles notifications automatically
  return null;
};

export default NotificationManager;
